/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { AIGenerateIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/product-card';

const styles = {
  svg: css`
    margin-bottom: -2px;
  `,
};

export const getAiSkillsTagNameAndIcon = () => {
  return {
    tagName: 'AI skills',
    translatedTagName: _t('AI skills'),
    icon: <AIGenerateIcon size="small" css={styles.svg} />,
  };
};
